import { NavLink } from '@propertypal/web-app/src/constants/navigation';
import { SearchState } from '../../reducers/search';

export const isActiveSearchSub = (link: NavLink, currentRoute: string, searchState?: SearchState): boolean => {
  // ensure current page is a search page and that link has a category
  if (currentRoute !== '/search' || !link.category || !link.saleType) return false;

  // get search category
  const category = searchState && searchState.resultParams && searchState.resultParams.category;
  const saleType = searchState && searchState.resultParams && searchState.resultParams.saleType;

  if (link.url?.startsWith('/residential-land-for-sale')) {
    return !!(
      category?.includes(link.category) &&
      saleType?.includes(link.saleType) &&
      searchState?.filters.styles.includes('residentialLand')
    );
  }

  if (link.url?.startsWith('/land-for-sale')) {
    return !!(
      category?.includes(link.category) &&
      saleType?.includes(link.saleType) &&
      !searchState?.filters.styles.includes('residentialLand')
    );
  }

  return !!(category?.includes(link.category) && saleType?.includes(link.saleType));
};

export const isActiveUrl = (
  link: NavLink,
  currentPath: string,
  currentRoute: string,
  searchState?: SearchState,
): boolean => {
  if (link.url === currentPath) {
    return true;
  }

  if (searchState && link.sublinks) {
    return link.sublinks.some((subLink) => {
      return isActiveSearchSub(subLink, currentRoute, searchState);
    });
  }

  return false;
};
